<template>
    <v-flex xs12>
        <div v-if="content.title!=''" class="headline mb-4">{{ content.title }}</div>
        <div class="course__text" v-html="content.text">
        </div>
    </v-flex>
</template>

<script>

export default {
  props: {
    content: {
      type   : Object,
      default: ()=> {},
    },
  },
};
</script>

